/**
 * Shared SVG pattern defs for IBCS-conformant chart rendering.
 * Include this once per page (e.g. at the top of the CashCockpitPage tree).
 * Patterns:
 *   url(#ibcs-hatch-forecast)  — diagonal stripes on dark slate for forecast bars/areas
 *   url(#ibcs-hatch-py)        — lighter diagonal stripes for Previous Year outlines
 */
export default function HatchPattern() {
    return (
        <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden>
            <defs>
                <pattern id="ibcs-hatch-forecast" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
                    <rect width="6" height="6" fill="#1F2937" />
                    <line x1="0" y1="0" x2="0" y2="6" stroke="#FFFFFF" strokeWidth="1.5" />
                </pattern>
                <pattern id="ibcs-hatch-py" patternUnits="userSpaceOnUse" width="5" height="5" patternTransform="rotate(45)">
                    <rect width="5" height="5" fill="#9CA3AF" />
                    <line x1="0" y1="0" x2="0" y2="5" stroke="#FFFFFF" strokeWidth="1" />
                </pattern>
            </defs>
        </svg>
    );
}

// IBCS color constants — single source of truth
export const IBCS = {
    actual: '#1F2937',           // slate-800
    actualLight: '#4B5563',      // slate-600 (subtotals, secondary fills)
    previousYear: '#9CA3AF',     // gray-400
    budgetStroke: '#1F2937',
    forecastPattern: 'url(#ibcs-hatch-forecast)',
    pyPattern: 'url(#ibcs-hatch-py)',
    positive: '#2C7BB6',         // favorable delta
    negative: '#D7191C',         // unfavorable delta
    forecastAccent: '#F28C28',   // orange for forecast-delta highlights
    neutralBg: '#F3F4F6',        // gray-100 cell backgrounds
    gridLine: '#E5E7EB',         // gray-200
} as const;

/** Semantic color for a variance amount (favorable/unfavorable). */
export function varianceColor(amount: number, opts?: { forecast?: boolean }): string {
    if (opts?.forecast) return IBCS.forecastAccent;
    return amount >= 0 ? IBCS.positive : IBCS.negative;
}
